import React from 'react';

const LinksTab = ({ selected, links, getLink }) => {
  if (!links) {
    return null;
  }

  return (
    <div className={`tabbed-content-container${selected ? ' selected' : ''}`}>
      <h2>{links.title}</h2>
      <ul>
        {links.data.map((link, index) => (
          <li key={index}>
            <a href={getLink(link.link)} target="_blank" rel="noreferrer">
              {link.description}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LinksTab;
